import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/services/app/app.service';
import { CourseService } from 'src/app/services/course/course.service';
import { IndividualService } from 'src/app/services/individual/individual.service';
import { Location } from '@angular/common';
import { StripePaymentComponent } from '../../stripe-payment/stripe-payment.component';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common/common.service';
import { EncryptionDecryptionService } from 'src/app/services/encryption-decryption/encryption-decryption.service';
import { ViewCoursePreviewComponent } from '../../courses/view-course-preview/view-course-preview.component';
import { InfoModalComponent } from '../../dialog-modal/info-modal/info-modal.component';



@Component({
  selector: 'app-course-details-c',
  templateUrl: './course-details-c.component.html',
  styleUrls: ['./course-details-c.component.scss']
})
export class CourseDetailsCComponent {


  public panelOpenState: boolean = true;
  public sectionArr: any[] = [

  ]
  public courseData!: any;
  private paramsData!: any;
  public isSpinnerLoading: boolean = false;
  public courseType!: string;
  public courseItemType!: string; //this is used to know course is of company or admin
  public isExpandAll: boolean = false;
  public sectionId!: number;
  public subSectionData: any = {}
  private vatPercentage;
  constructor(private router: Router, private courseService: CourseService, private activatedRoute: ActivatedRoute, private appService: AppService,
    private individualService: IndividualService, public location: Location, private dialog: MatDialog, public commonService: CommonService, private route: ActivatedRoute,
    public ed: EncryptionDecryptionService) { }
  panels = ['First', 'Second', 'Third'];
  ngOnInit(): void {
    this.commonService.setTitle("Courses")
    this.activatedRoute.queryParams.subscribe((params: any) => {
      this.paramsData = params;
      //here t means type of course 
      if (params["t"]) {
        this.courseType = params["t"]
      }
      if (params["c_t"]) {
        this.courseItemType = params["c_t"]
      }
      if (this.courseType == "d_cs" || this.courseType == "b_cs") {
        let data = {
          c_i: params["c_i"]
        }
        if ((this.courseItemType == null) || (this.courseItemType == '')) {
          this.courseItemType = "a"
        }
        this.viewCourse(data)
      }
      else {
        let data = {
          c_i: params["c_i"],
          p_i: params["p_i"],
          pc_i: params["pc_i"]
        }
        this.detail(data)
      }
    })
  }
  viewCourse(data) {
    let obj = {
      c_i: data.c_i,
      refferral_code: data.referral_code,
      t: this.courseItemType
    }
    this.isSpinnerLoading = true;
    this.individualService.viewCourse(obj).subscribe({
      next: (success: any) => {
        this.isSpinnerLoading = false;
        if (success.status == 200) {
          this.courseData = success.data["cs"];
          this.sectionArr = success.data["sec"]
          this.vatPercentage = success.data["vat"]
        }
      },
      error: (error: any) => {
        this.isSpinnerLoading = false;
        this.commonService.handleError(error)
      }
    }

    )
  }
  detail(data) {
    let dataObj = {
      c_i: data.c_i,
      p_i: data.p_i,
      pc_i: data.pc_i,
      t: this.courseItemType
    }
    this.isSpinnerLoading = true;
    this.individualService.detail(dataObj).subscribe({
      next: (success: any) => {
        this.isSpinnerLoading = false;
        if (success.status == 200) {
          this.courseData = success.data["cs"];
          this.sectionArr = success.data["sec"]
          // this.vatPercentage=success.data["vat"]
        }
      },
      error: (error: any) => {
        this.isSpinnerLoading = false;
        this.commonService.handleError(error)
      }
    }
    );
  }
  onExpandAll() {
    this.isExpandAll = !this.isExpandAll
  }
  onSubSection(section_id: string, subs_data, item: any) {
    //subs_data=sub section data
    //item is section data
    //here creating the sub section id array and storing in session storage // used to start the next section
    let data = {
      c_i: this.paramsData.c_i, //course id
      p_i: this.paramsData.purchase_id, //purchase
      s_i: item.section_id, //section
      s_si: subs_data.sub_section_id, //sub section
      p_si: 0,                  //purchase course (Value : 1=> my course 0=> if any other course)
      c_t: this.courseData.t,
    }
    // here m_cs meanse my course if my course then course will always be purchased hence set it as 1
    // if(this.courseType=="m_cs"){
    //   data["p_si"]=1
    // }
    // //if type is exam then go to exam's page or else sub section array
    // if (subs_data.type != 'exam') {
    //   this.router.navigate([ this.navigateCourseTypeWise()+'/sub-section'], { queryParams: data })
    // }
    // else {
    //   data["e_i"] = subs_data.exam_id
    //   data["type"] = "overall"
    //   this.router.navigate([this.navigateCourseTypeWise()+'/exam'], { queryParams: data })
    // }
  }
  onSubSectionNew() {
    let data = {
      c_i: this.paramsData.c_i, //course id
      p_i: this.paramsData.p_i, //purchase
      s_i: this.sectionArr[0]["s_i"], //section
      s_si: this.sectionArr[0]["sub_s"][0]["s_si"], //sub section
      p_si: 0,                  //purchase course (Value : 1=> my course 0=> if any other course)
      c_t: this.courseData.t,
      section_arr: this.sectionArr,
      title: this.courseData.tit
    }
    if (this.courseType == "m_cs") {
      data["p_si"] = 1
    }
    this.appService.storeSessionData('courseData', JSON.stringify(data))
    // here m_cs meanse my course if my course then course will always be purchased hence set it as 1
    if (this.courseType == "m_cs") {
      data["p_si"] = 1
    }
    //if type is exam then go to exam's page or else sub section array
    if (this.subSectionData.type != 'exam') {
      this.router.navigate(['/sub-section-new'])
    }
    else {
      data["e_i"] = this.subSectionData.exam_id
      data["type"] = "overall"
      this.router.navigate([this.navigateCourseTypeWise() + '/exam'])
    }
  }
  onBack() {
    if (this.appService.getSessionData('deepLinkData')) {
      this.appService.removeSessionData('deepLinkData')
      this.router.navigate(['/individual/dashboard'])
    }
    else {
      this.location.back()
    }

  }
  navigateCourseTypeWise() {
    if (this.courseType == "m_cs") {
      return 'individual/my-course'
    }
    else if (this.courseType == "d_cs") {
      return 'individual/dashboard'
    }
    else {
      return 'individual/courses'
    }
  }
  onBuyCourse(id, item) {
    // let data = {
    //   id: id,
    // }
    // data = Object.assign(data, item)
    // data["id"] = id;
    // data["vat_percentage"] = this.vatPercentage
    // // send type as 1 as it will be always single course
    // data["type"] = 1
    // const dialogRef = this.dialog.open(StripePaymentComponent, {
    //   width: '95%',
    //   height: '98%',
    //   minWidth:'300px',
    //   maxHeight:'850px',
    //   maxWidth: '1090px',
    //   panelClass: 'addCourseModal',
    //   enterAnimationDuration: '300ms', exitAnimationDuration: "300ms",
    //   data: data,
    //   autoFocus: false
    // });
    // dialogRef.afterClosed().subscribe(result => {
    // });
    const dialogRef = this.dialog.open(InfoModalComponent, {
      data: {
        type: 'info_mess'
      }
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }
  onCoursePreview() {
    if (this.sectionArr.length == 0) {
      return this.appService.showToastMessage('warning', 'No preview available for this course.')
    }
    let data = {
      id: this.courseData.id,
      t: this.courseData.t,
      parentMenu: 'preview_course',
      freePreview: true,
    }
    const dialogRef = this.dialog.open(ViewCoursePreviewComponent, {
      width: '96%',
      height: '100%',
      maxHeight: '900px',
      // maxHeight: "800px",
      maxWidth: '100vw',
      panelClass: 'addCourseModal',
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms",
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  ngOnDestroy(): void {

    if (this.appService.getSessionData('deepLinkData')) {
      this.appService.removeSessionData('deepLinkData')
    }
  }

}
